// extracted by mini-css-extract-plugin
module.exports = {"container":"AdvancedPricingTag_container__ObVVV"};